import api from '../../../../resources/apiProvider'
import userService from '../../../../services/userService'
import _ from 'lodash'
import toastr from 'toastr/build/toastr.min'
import Treeselect, { ASYNC_SEARCH, LOAD_ROOT_OPTIONS} from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
    name: 'adminPam',
    components: {Treeselect},
    data() {
        return {
            listUsers: null,
            userInLocal: false,
            selectedWdrUser: undefined,
            pam: false
        }
    },
    watch: {
        getselectedWdrUser: function (val) {
            let vm = this
            let selectUserWdr = _.cloneDeep(val)
            if (selectUserWdr) {
                if(vm.getUserInfos("pam")) {
                    vm.pam = vm.getUserInfos("pam")
                }
                else {
                    vm.pam = false
                }
            }
            console.log(selectUserWdr)
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        async getListUser() {
            let resList = api.getFromUri(api.getResourceUri().user.base)
            let list = await resList.get()
            this.listLocalUser = list.data.rows
        },
        /**
         * Recherche asynchrone d'uilisateurs avec le champ texte
         */
        async searchUser({ action, searchQuery, callback }) {
            const vm = this
            if (action === ASYNC_SEARCH) {
                if (!searchQuery || searchQuery.length < 4) {
                    callback("Rentrez au moins 4 charactères", null)
                    return
                }
                const resWdrUser = api.getFromUri(api.getResourceUri().wdrUser.getAll)
                const result = await resWdrUser.get({searchQuery})
                const users = result.data.map((user) => { return {
                    id: user.id,
                    label: user.firstName + ' ' + user.lastName,
                    simpleReporting: user.simpleReporting,
                    todReporting: user.todReporting,
                }})
                vm.listUsers = users
                callback(null, users)
            }
        },
        /**
         * Sauvegarde des habilitations données à l'utilisateur
         */
        saveProcess() {
            let vm = this
            let selectUserWdr = vm.getselectedWdrUser

            let newUser = {
                id: selectUserWdr.id,
                todReporting: vm.getTodReportingObject
            }

            //let networksListFormatted = this.getNetworksListFormatted(this.listNetworksSelected)

            userService.updateUser(newUser).then(() => {
                toastr.success('Enregistrement effectué')
            })

        },
        /**
         * Récupérer l'info indiquée de l'utilisateur
         */
        getUserInfos(info) {
            if (!this.getselectedWdrUser) {
                return false
            }
            const user = this.getselectedWdrUser
            // eslint-disable-next-line
            return !_.isUndefined(user['todReporting'][info]) ? user['todReporting'][info] : undefined
        }
    },
    computed: {
        userIsAllowed() {
            return this.$store.storeAuth.getters.pam
        },
        getselectedWdrUser() {
            if (!this.selectedWdrUser || _.isEmpty(this.selectedWdrUser)) {
                return undefined
            }
            return this.listUsers.find((user) => this.selectedWdrUser === user.id )
        },
        getTodReportingObject() {
            return {
                pam: this.pam,
                isAdmin: this.getselectedWdrUser.todReporting.isAdmin,
                networksAuthorize: (this.getselectedWdrUser.todReporting.networksAuthorize) ? this.getselectedWdrUser.todReporting.networksAuthorize : []
            }
        }
    },
}